<template>
  <custom-dialog
    :widthDialog="'360px'"
    :classDialog="'hastag-dialog'"
    :offsetTop="''"
    :openDialog="isOpen"
    :appendToBody="true"
    :modalAppendToBody="true"
    @closeDialog="$emit('closeDialog', {processTypeSelect: null, hashTagSelected: null})"
    @closed="$emit('dialogClosed', {processTypeSelect: null, hashTagSelected: null})"
  >
    <template #body>
      <div class="title flex-row">
        <h2 class="dialogTitle">
          Hình thức xử lý
        </h2>
      </div>
      <div class="dialog-body padding-bottom-20">
        <span
          class="padding-left-right-10"
        >
          <el-radio-group v-model="processTypeRadio" @change="changeProcessType">
            <el-radio :label="PROCESS_TYPE_CHU_TRI">Chủ trì</el-radio>
            <el-radio :label="PROCESS_TYPE_PHOI_HOP">Phối hợp</el-radio>
            <el-radio :label="PROCESS_TYPE_NHAN_DE_BIET">Nhận để biết</el-radio>
          </el-radio-group>
        </span>
      </div>
    </template>
  </custom-dialog>
</template>

<script>

import constants from "../../../constants";

export default {
  name: "chuyenXuLy-hashtag-dialog",
  props: ["isOpen", "hashTagSelected"],
  components: {
    customDialog: () => import('../../common/custom-dialog.vue'),
  },
  data() {
    return {
      processTypeRadio: null,
      PROCESS_TYPE_CHU_TRI : constants.PROCESS_TYPE.CHUTRI,
      PROCESS_TYPE_PHOI_HOP : constants.PROCESS_TYPE.PHOIHOP,
      PROCESS_TYPE_NHAN_DE_BIET : constants.PROCESS_TYPE.NHANDEBIET,
    }
  },
  created() {
    this.processTypeRadio = null;
  },
  methods: {
    changeProcessType() {
      this.$emit('closeDialog', {processTypeSelect: this.processTypeRadio, hashTagSelected: this.hashTagSelected});
      this.processTypeRadio = null;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/doc-in/components/chuyenXuLy-hashtag-dialog.vue